import { UxService } from '../../../core/services/ux.service';
import { TelepainApiBase } from './telepain-api.base';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RoleService } from '../../core/services/role.service';
import { CuresReport } from '../models/cures-report'
import { IApi } from '../../core/services';

@Injectable({
  providedIn: 'root'
})
export class CuresReportService extends TelepainApiBase<CuresReport>{

  details: IApi<any>;
  getcuresReport: IApi<any>;
  runCuresReport: IApi<any>;
  updateCuresReport: IApi<any>;

  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    // super('patient-cures-report', http, roleService, uxService);
    super('v1/patient-bamboo-report/getPDMPReportSearch', http, roleService, uxService);
    this.details = new TelepainApiBase<any>(`v1/patient-cures-report/details`, http, roleService, uxService);
    this.getcuresReport = new TelepainApiBase<any>(`v1/patient-cures-report`, http, roleService, uxService);
    this.runCuresReport = new TelepainApiBase<any>(`v1/patient-cures-report`, http, roleService, uxService);
    this.updateCuresReport = new TelepainApiBase<any>(`v1/patient-cures-report`, http, roleService, uxService);
  }
}
